<script>

import { keydownWrapper } from '$lib/app/lib.js';

let { target_id } = $props();

let areaChecked = $state(false);

function handlePasswordToggle(e) {
    e.preventDefault();
    const the_eye = e?.currentTarget;
    if(the_eye) {
        const el = document.getElementById(target_id);

        if(el) {
            const icon_url = the_eye.querySelector('use').getAttributeNS('http://www.w3.org/1999/xlink', 'href');
            if(icon_url == '/i/fa.svg#eye') {
                the_eye.querySelector('use').setAttributeNS('http://www.w3.org/1999/xlink', 'href', '/i/fa.svg#eye-slash');
                el.type = 'text';
                areaChecked = true;
            } else if(icon_url == '/i/fa.svg#eye-slash') {
                the_eye.querySelector('use').setAttributeNS('http://www.w3.org/1999/xlink', 'href', '/i/fa.svg#eye');
                el.type = 'password';
                areaChecked = false;
            }
        }
    }
}

</script>
<!-- svelte-ignore a11y_no_noninteractive_tabindex -->
<svg class='svg-icon clickable-icon is-medium'
    tabindex=0 role='switch' aria-checked={areaChecked}
    onclick={handlePasswordToggle}
    onkeydown={keydownWrapper(handlePasswordToggle)}><use xlink:href='/i/fa.svg#eye'></use></svg>
